import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import TabContext from "@mui/lab/TabContext";

import Divider from "@mui/material/Divider";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
    paddingTop: "0.35rem",
  },
  tab: {
    paddingLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
    textTransform: "none",
    fontWeight: "bold",
    fontFamily: '"Source Sans Pro",sans-serif',
  },
  tabPanel: {
    padding: "0",
    "& .MuiBox-root": {
      padding: "0px",
    },
  },
}));

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default function CustomVerticalTabs(props) {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  const { data } = props;

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={2} lg={2}>
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={value}
          onChange={handleTabChange}
          aria-label="Vertical tabs"
          className={classes.tabs}
          TabIndicatorProps={{ style: { background: "#91C73C" } }}
        >
          {data.map(({ value, name }) => (
            <Tab
              key={value}
              className={classes.tab}
              label={name}
              value={value}
              {...a11yProps(value)}
            />
          ))}
        </Tabs>
      </GridItem>
      <GridItem xs={12} sm={12} md={10} lg={10}>
        <TabPanel
          key={data.label}
          value={data.value}
          className={classes.tabPanel}
        >
          {data[value].component}
        </TabPanel>
      </GridItem>
    </GridContainer>
  );
}
